// extracted by mini-css-extract-plugin
export var borderRadius = "_dj-4";
export var large = "_dj-3";
export var logoContainer = "_dj-0";
export var nameLogo = "_dj-2";
export var small = "_dj-1";